import "./Managecity.css";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import {
  getCountryList,
  getZoneList,
  getStateList,
  createCity,
  getCityList,
  updateCityStatus,
  updateCity,
  getfilteredZoneList,
  getCountryListActive,
  getStateListsearch,
  exportCityList,
  fetchCountryDropdown,
} from "../../../API Service/apiService";
import CommonButton from "../../../Componants/Common/Button";
import {
  Autocomplete,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import ExportToExcel from "../../../Componants/Common/ExportToExcel";
import Paginate from "../../../Componants/Common/Paginate";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import activeIcon from "../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";
import Subheader from "../../../Componants/Common/Subheader";
import config from "../../../Componants/Common/config";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../Componants/Loader/Loader";
import FileSaver from "file-saver";

const cityHeaders = [
  { label: "S. No.", key: "serialNumber" },
  { label: "Country", key: "countryName" },
  { label: "Zone", key: "zoneName" },
  { label: "State", key: "stateName" },
  { label: "City", key: "cityName" },
  { label: "Status", key: "active" },
];

const Managecity = () => {
  const topRef = useRef(null);
  const pageSize = config.pageSize;
  const dummyGetList = {
    serialNo: "",
    countryName: "",
    zoneName: "",
    stateName: "",
    cityName: "",
    pageSize: pageSize,
  };

  const [countries, setCountries] = useState([]);
  const [countryDropdown, setCountryDropdown] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);

  const [filteredCities, setFilteredCities] = useState([]);

  const [editIndex, setEditIndex] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedZone, setSelectedZone] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [searchActivated, setSearchActivated] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const itemsPerPage = 10;

  // const totalItems = filteredCities.length;

  // Calculate the current items to display
  const startIndex = (currentPage - 1) * itemsPerPage;

  // const paginatedCities = filteredCities.slice(
  //   startIndex,
  //   startIndex + itemsPerPage
  // );

  const [dataSize, setDataSize] = useState(pageSize);
  const [zoneAddDropdown, setZoneAddDropdown] = useState([]);
  const [zoneId, setZoneId] = useState(null);
  const [searchParams, setParams] = useState({
    ...dummyGetList,
  });

  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(1);
  const [tableData, setTableData] = useState([]);
  const cells = ["S.No", "Country", "Zone", "State", "city", "Action"];
  const [limit, setLimit] = useState(10);
  const [countryId, setCountryId] = useState(null);
  const [cityName, setcityName] = useState(null);
  const [stateName, setstateName] = useState(null);
  const [zoneName, setZoneName] = useState(null);
  const [stateId, setstateId] = useState(null);
  const [filteredzones, setfilteredzones] = useState([]);
  const [selstateName, setselstateName] = useState(null);
  const [selZoneName, setselZoneName] = useState(null);
  const [selCountry, setselCountry] = useState(null);
  const [countryId2, setCountryId2] = useState(null);
  const [filteredzones2, setfilteredzones2] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [selCountry2, setselCountry2] = useState(null); // Selected country object for the second API
  // Zone-related states
  const [selZoneId2, setselZoneId2] = useState(null); // Selected zone ID for the second API
  const [selZoneName2, setselZoneName2] = useState(null); // Selected zone object for the second API
  const [stateId2, setstateId2] = useState(null); // Selected state ID for the second API
  const [selstateName2, setselstateName2] = useState(null); // Selected state object for the second API
  const [filStates2, setFilStates2] = useState([]); // Filtered states for the second API
  const [FilteredCityList, setFilteredCityList] = useState([]);
  const [countryError, setCountryError] = useState(false);
  const [zoneError, setZoneError] = useState(false);
  const [stateError, setStateError] = useState(false);
  const [cityError, setCityError] = useState(false);
  const [status, setStatus] = useState(true);
  const [countriesActive, setCountriesActive] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [flag, setFlag] = useState(false);
  const handlePageChange = (newPage) => {
    setIsSearching(false);
    setPage(newPage);
    setParams((prevParams) => ({
      ...prevParams,
      pageIndex: newPage.toString(),
    }));
  };
  // const fetchCountries = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await getCountryList();
  //     setCountries(response.data.countries);
  //     console.log("Countries fetched:", response.data);
  //   } catch (error) {
  //     console.error("Error fetching countries:", error);
  //     toast.error("Failed to fetch countries");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchCountries();
  // }, []);


    const fetchCountries = async () => {
      try {
        setLoading(true);
        const response = await fetchCountryDropdown();
        // setCountries(response.data.countries);
        setCountryDropdown(response.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
        toast.error("Failed to fetch countries");
      } finally {
        setLoading(false);
      }
    };
  
     const fetchAllCountries = async () => {
      try {
        setLoading(true);
        const response = await fetchCountryDropdown({callType:0});
        // setCountries(response.data.countries);
        setAllCountries(response.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
        toast.error("Failed to fetch countries");
      } finally {
        setLoading(false);
      }
    };

     useEffect(() => {
    fetchCountries();
    fetchAllCountries();
  }, []);

  const fetchZones2 = async () => {
    try {
      if (countryId2) {
        setLoading(true);
        const response = await getfilteredZoneList(1, limit, countryId2);
        setfilteredzones2(response.data.zones);
        console.log("filtered zones", response.data.zones);
      }
    } catch (error) {
      console.error("Error fetching zones:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchZones2();
  }, [countryId2]);

  const fetchFilState2 = async () => {
    try {
      if (selZoneId2) {
        setLoading(true);
        const response = await getStateListsearch(countryId2, selZoneId2);
        setFilStates2(response.data.states || []);
        console.log("Response for Zone ID 2:", response.data);
      }
    } catch (error) {
      console.error("Error fetching states for Zone ID 2:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFilState2();
  }, [selZoneId2]);

  const fetchCities = async () => {
    try {
      if (!isSearching || flag) {
        setLoading(true);
        const response = await getCityList("", "", "", page, limit, "");
        setCities(response.data.cities);
        console.log("response.data", response.data);
        setTotalRecords(response.data.totalCities);
        setTableData(response.data.cities);
        setLoading(false);
        // setFilteredZones(response.data.zones);
        // setFilteredCountries(response.data.countries);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  useEffect(() => {
    fetchCities();
  }, [page]);

  const fetchFiltereCities = async () => {
    try {
      if (stateId && !isEditing) {
        setLoading(true);
        const response = await getCityList(
          countryId,
          zoneId,
          stateId,
          1,
          limit
        );
        setFilteredCities(response.data.cities);
        console.log("response.data", response.data);
        // setTotalRecords(response.data.totalCities);
        // setTableData(response.data.cities);
        setLoading(false);
        // setFilteredZones(response.data.zones);
        // setFilteredCountries(response.data.countries);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  useEffect(() => {
    fetchFiltereCities();
  }, []);

  useEffect(() => {
    const fetchZonesForCountry = async () => {
      if (!countryId) return;
      try {
        setLoading(true);
        const response = await getfilteredZoneList(1, limit, countryId);
        setfilteredzones(response.data.zones);
      } catch (error) {
        console.error("Error fetching zones:", error);
        toast.error("Failed to fetch zones");
      } finally {
        setLoading(false);
      }
    };
    fetchZonesForCountry();
  }, [countryId]);

  useEffect(() => {
    const fetchStatesForZone = async () => {
      if (!zoneId || !countryId) return;
      try {
        setLoading(true);
        const response = await getStateListsearch(countryId, zoneId, "true");
        setStates(response.data.states || []);
      } catch (error) {
        console.error("Error fetching states:", error);
        toast.error("Failed to fetch states");
      } finally {
        setLoading(false);
      }
    };
    fetchStatesForZone();
  }, [zoneId, countryId]);

  const fetchFilteredCitiesByState = async () => {
    try {
      if (stateId2) {
        setLoading(true);
        const response = await getCityList(
          countryId2,
          selZoneId2,
          stateId2,
          1,
          limit
        );
        setFilteredCityList(response.data.cities);
        console.log("Fetched cities data:", response.data);
        // Additional updates can go here
        // setTotalRecords(response.data.totalCities);
        // setTableData(response.data.cities);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  useEffect(() => {
    fetchFilteredCitiesByState();
  }, [stateId2]);

  const fetchZones = async () => {
    try {
      if (countryId && !isEditing) {
        setLoading(true);
        const response = await getfilteredZoneList(1, limit, countryId, status);
        setfilteredzones(response.data.zones);
        console.log("filtered zones", response.data.zones);
      }
    } catch (error) {
      console.error("Error fetching zones:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchZones();
  }, [countryId]);

  const [postData, setPostData] = useState({
    countryId: "",
    zoneId: "",
    stateId: "",
    cityName: "",
    displayOrder: "",
    remarks: "",
  });

  const handleStatus = async (_id) => {
    try {
      setLoading(true);
      const response = await updateCityStatus({ id: _id });
      console.log(`status resposne : ${response.data.message}`);

      if (response.status === "success") {
        toast.success("Status Updated Successfully");
      }
    } catch (error) {
      console.log(`Error updating status ${error}`);
       const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      "Failed to update status";

    toast.error(message);
    } finally {
      if (!isSearching) {
        fetchCities();
      } else {
        // setselstateName2(stateName);
        handleSearch();
      }

      setLoading(false);
    }
  };

  const handleCancel = async () => {
    // Clear all form fields
    setEditIndex(false);
    setCountryId(null);
    setZoneId(null);
    setstateId(null);
    setcityName("");
    setSelectedCountry(null);
    setZoneName(null);
    setstateName(null);
    setSelectedCity(null);
    setselCountry2(null);
    setCountryId2(null);
    setselZoneId2(null);
    setselZoneName2(null);
    setstateId2(null);
    setselstateName2(null);
    setFilteredCityList([]);
    setfilteredzones([]);
    setfilteredzones2([]);
    setFilStates2([]);
    setFilteredCities([]);
    // setTableData([]); // Do not clear the table data here, it causes flicker
    setPage(1);
    setIsSearching(false);
    setFlag(false);
    // Reset error states
    setCountryError(false);
    setZoneError(false);
    setStateError(false);
    setCityError(false);
    
    // Fetch initial city data manually to avoid stale state in fetchCities closure
    try {
      setLoading(true);
      const response = await getCityList("", "", "", 1, limit, "");
      setCities(response.data.cities);
      setTotalRecords(response.data.totalCities);
      setTableData(response.data.cities);
    } catch (error) {
      console.error("Error fetching cities:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePostRequest = async () => {
    let isValid = true;

    if (!countryId) {
      setCountryError(true);
      isValid = false;
    } else {
      setCountryError(false);
    }

    if (!zoneId) {
      setZoneError(true);
      isValid = false;
    } else {
      setZoneError(false);
    }

    if (!stateId) {
      setStateError(true);
      isValid = false;
    } else {
      setStateError(false);
    }

    if (!cityName) {
      setCityError(true);
      isValid = false;
    } else {
      setCityError(false);
    }

    if (!isValid) {
      // toast.error("Please fill all the fields");
      return;
    } else {
      console.log("Post Data is:", postData);
      try {
        setLoading(true);
        let response;
        const postData = {
          countryId: countryId,
          zoneId: zoneId,
          stateId: stateId,
          cityName: cityName,
        };
        if (editIndex) {
          const postData = {
            _id: editIndex,
            countryId: countryId,
            zoneId: zoneId,
            stateId: stateId,
            cityName: cityName,
          };
          // Update city using PUT
          response = await updateCity(postData); // Call update API
          console.log("data is", postData);
          console.log(postData);
          toast.success("City updated successfully!");
          setEditIndex(false); // Reset the `editIndex` after update
          setCountryId(null);
          setZoneId(null);
          setSelectedCountry(null);
          setZoneName(null);
          setstateName(null);
          setstateId(null);
          setcityName(null);
          setEditIndex(null);
          setIsEditing(null);
        } else {
          response = await createCity(postData);
          console.log("data is", postData);
          toast.success("City Added Successfully");
             setCountryId(null);
             setZoneId(null);
             setSelectedCountry(null);
             setZoneName(null);
             setstateName(null);
             setstateId(null);
             setcityName(null);
             setEditIndex(null);
             setIsEditing(null);
        }
        // Reset the postData
      } catch (error) {
        console.log(`Error updating status ${error}`);
        const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to update status";

        toast.error(message);
      } finally {
        if (!isSearching) {
          fetchCities();
        } else {
          // setselstateName2(stateName);
          handleSearch();
        }
      }
      setLoading(false);
    }
  };

  const handleEdit = (
    _id,
    countryId,
    zoneId,
    countryName,
    zoneName,
    stateName,
    stateId,
    cityName
  ) => {
    setIsEditing(true);
    setEditIndex(_id);
    setCountryId(countryId);
    setZoneId(zoneId);
    setSelectedCountry(countryName);
    setZoneName(zoneName);
    setstateName(stateName);
    setstateId(stateId);
    setcityName(cityName);
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleSearch = async () => {
    try {
      setLoading(true);
      setPage(1);
      setIsSearching(true);
      // Fetch data based on the selected values
      const response = await getCityList(
        countryId2 || "",
        selZoneId2 || "",
        stateId2 || "",
        1,
        limit,
        selectedCity || ""
      );
      setFilteredCities(response.data.cities);
      console.log("response.data", response.data);
      setTotalRecords(response.data.totalCities);
      setTableData(response.data.cities);
      if (totalRecords > 10) {
        setFlag(true);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleExport = async () => {
    try {
      setLoading(true);
      const updatedParams = {countryId:countryId2,zoneId:selZoneId2,stateId:stateId2,cityName:selectedCity,page: -1, limit: -1 };
      const response = await exportCityList(updatedParams);
      if (response?.status === "success" && response?.data?.filePath) {
        window.location.href = response.data.filePath;
        toast.success("File downloaded successfully");
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      console.error("Error in downloading file:", error);
      toast.error(error.message || "Error in downloading file");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="Managecity-container" ref={topRef}>
      {loading && <Loader />}
      <Toaster position="top-center" reverseOrder={false} />
      <HeaderNavigation value={"Location > City"} location={"/setting"} />
      <div className="autocompleteform-Managecity">
        {/* {countryId} {zoneId} {stateId} {page} {limit}{selectedCity} */}
        <Subheader heading={"Add City"} />
        <div className="textbox-main-Managecity">
          <div className="line-Managecity">
            <div className="textinput-Managecity">
                <Autocomplete
                  id="country-autocomplete"
                  clearOnEscape
                  options={countryDropdown}
                  getOptionLabel={(option) => option.countryName || ""}
                  value={
                    typeof selectedCountry === "string"
                      ? countryDropdown.find((c) => c.countryName === selectedCountry) || null
                      : selectedCountry || null
                  }
                  onChange={(event, value) => {
                    setCountryId(value?._id || null);
                    setSelectedCountry(value || null);

                    // Reset all dependent fields when the country is changed
                    setZoneId(null);
                    setZoneName(null);
                    setstateId(null);
                    setstateName(null);
                    setfilteredzones([]);
                    setStates([]);
                    setcityName(null);

                    setCountryError(false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Country"
                      variant="standard"
                      required
                      error={countryError}
                      helperText={countryError ? "Country is required." : null}
                    />
                  )}
                />
            </div>

            <div className="textinput-Managecity">
                <Autocomplete
                  id="zone-autocomplete"
                  clearOnEscape
                  options={filteredzones}
                  value={
                    typeof zoneName === "string"
                      ? filteredzones.find((z) => z.zoneName === zoneName) || null
                      : zoneName || null
                  }
                  getOptionLabel={(option) => option.zoneName || ""}
                  onChange={(event, value) => {
                    setZoneId(value?._id || null);
                    setZoneName(value || null);

                    // Clear dependent fields
                    setstateId(null);
                    setstateName(null);
                    setStates([]);
                    setcityName(null);

                    setZoneError(false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Zone"
                      variant="standard"
                      required
                      error={zoneError}
                      helperText={zoneError ? "Zone is required." : null}
                      disabled={!countryId}
                    />
                  )}
                />
            </div>

            <div className="textinput-Managecity">
                <Autocomplete
                  clearOnEscape
                  id="state-autocomplete"
                  options={states}
                  value={
                    typeof stateName === "string"
                      ? states.find((s) => s.stateName === stateName) || null
                      : stateName || null
                  }
                  getOptionLabel={(option) => option.stateName || ""}
                  onChange={(event, value) => {
                    setstateId(value?._id || null);
                    setstateName(value || null);
                    setcityName(null);
                    setStateError(false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="State Name"
                      variant="standard"
                      required
                      error={stateError}
                      helperText={stateError ? "State is required." : null}
                      disabled={!zoneId}
                    />
                  )}
                />
            </div>

            <div className="textinput-Managecity">
              <TextField
                id="standard-basic"
                label="City"
                variant="standard"
                focused={!!cityName} // Focus only if cityName is not null or empty
                value={cityName || ""} // Default to an empty string if cityName is null
                inputProps={{ maxLength: 25 }}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z ]*$/.test(value)) {
                    if (selZoneId2 && stateId2) {
                      setSelectedCity(value);
                    }
                    setcityName(value); // Update cityName state
                    setCityError(false); // Clear error on input
                  }
                }}
                required
                error={cityError || (cityName && cityName.length < 2)}
                helperText={
                  cityError
                    ? "City is required."
                    : cityName && cityName.length < 2
                    ? "City must be at least 2 characters."
                    : null
                }
              />
            </div>
          </div>

          <div className="button-Managecity">
            <span className="buttons-Managecity-span">
              <CommonButton
                name={editIndex? "UPDATE" : "ADD"}
                handleOnClick={handlePostRequest}
              />
            </span>
            <span className="buttons-Managecity-span">
              <CommonButton name={"CANCEL"} handleOnClick={handleCancel} />
            </span>
          </div>
        </div>
      </div>

      <div className="autocompleteform-Managecity">
        <Subheader heading={"List View"} />
        <div className="line-Managecity">
          <div className="textinput-Managecity">
            <Autocomplete
              id="country-autocomplete"
              clearOnEscape
              options={allCountries}
              getOptionLabel={(option) => option.countryName}
              value={selCountry2 || null} // Controlled value
              onChange={(event, value) => {
                // Update country-related states
                setCountryId2(value?._id || null);
                setselCountry2(value || null);

                // Reset all dependent fields when the country is changed
                setselZoneId2(null);
                setselZoneName2(null);
                setstateId2(null);
                setselstateName2(null);
                setfilteredzones2([]); // Clear zones
                setFilStates2([]); // Clear states
                setSelectedCity(null);
                setFilteredCityList([]);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Country" variant="standard" />
              )}
            />
          </div>
          <div className="textinput-Managecity">
            <Autocomplete
              id="zone2-Autocomplete"
              clearOnEscape
              options={filteredzones2} // Updated for second API
              getOptionLabel={(option) => option.zoneName || ""}
              value={selZoneName2 || null} // Controlled value for second API
              onChange={(event, value) => {
                // Update zone-related states for the second API
                setselZoneId2(value?._id || null);
                setselZoneName2(value || null);

                // Reset all dependent fields when the zone is changed
                setstateId2(null);
                setselstateName2(null);
                setSelectedCity(null);
                setFilStates2([]); // Clear states
                setFilteredCityList([]);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Zone"
                  variant="standard"
                  className="mt-1 app-input-width"
                />
              )}
            />
          </div>
          <div className="textinput-Managecity">
            <Autocomplete
              id="state2-autocomplete"
              clearOnEscape
              options={filStates2} // Using the states list from the second API
              getOptionLabel={(option) => option.stateName || ""} // Display the state name
              value={
                filStates2.find((state) => state.stateName === selstateName2) ||
                null
              } // Ensure the value matches an option
              onChange={(event, value) => {
                // Update state-related states for the second API
                setstateId2(value?._id || null); // Set the selected state ID
                setselstateName2(value ? value.stateName : null); // Set the selected state name

                // Reset city-related fields when the state is changed
                setSelectedCity(null);
                setFilteredCityList([]);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="State Name"
                  variant="standard"
                  className="mt-1 app-input-width"
                />
              )}
            />
          </div>
          <div className="textinput-Managecity">
            <Autocomplete
              id="city-autocomplete"
              options={FilteredCityList}
              getOptionLabel={(option) => option.cityName}
              value={
                FilteredCityList.find(
                  (city) => city.cityName === selectedCity
                ) || null
              }
              onChange={(event, newValue) => {
                // Update city-related states
                setSelectedCity(newValue ? newValue.cityName : null);
              }}
              renderInput={(params) => (
                <TextField {...params} label="City" variant="standard" />
              )}
            />
          </div>
          <span className="buttons-Managecity-span">
            <CommonButton name="Search" handleOnClick={handleSearch} />
          </span>
          &nbsp;&nbsp;&nbsp;
          <span className="buttons-Managecity-span">
            <CommonButton name="Cancel" handleOnClick={handleCancel} />
          </span>
        </div>

        <div className="table-Managecity">
          <div className="excelexport-Managecity">
            <span className="buttons-Managecity-span">
              <ExportToExcel onClick={handleExport} />
              
            </span>
          </div>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  {cells.map((cell, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        color: "white",
                        textAlign:
                          index === cells.length - 1 ? "right" : "center",
                        paddingRight: index === cells.length - 1 ? "4rem" : "",
                      }}
                    >
                      {cell}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No Data Available
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        {(page - 1) * dataSize + index + 1}
                      </TableCell>
                      <TableCell align="center">{row.countryName}</TableCell>
                      <TableCell align="center">{row.zoneName}</TableCell>
                      <TableCell align="center">{row.stateName}</TableCell>
                      <TableCell align="center">{row.cityName}</TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                        }}
                      >
                        <IconButton
                          onClick={() => handleStatus(row._id)}
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={
                              row.active === false ? inactiveIcon : activeIcon
                            }
                            alt="active"
                            height="20px"
                            width="20px"
                          />
                        </IconButton>

                        <IconButton
                          onClick={() =>
                            handleEdit(
                              row._id,
                              row.countryId,
                              row.zoneId,
                              row.countryName,
                              row.zoneName,
                              row.stateName,
                              row.stateId,
                              row.cityName
                            )
                          }
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={editIcon}
                            alt="Edit"
                            height={"20px"}
                            width={"20px"}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className="pagination-container">
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            dataSize={dataSize}
          />
        </div>
      </div>
    </div>
  );
};

export default Managecity;
